<template functional>
  <div class="my-5 text-center">
    <h1>Uh oh...</h1>
    <h3>The {{ props.resource }} you were looking for was not found.</h3>
  </div>
</template>

<script>
export default {
  props: {
    resource: {
      type: String,
      default: "page"
    }
  }
}
</script>
